export const invoiceTemplates = [
  {
    value: 'STANDARD',
    title: 'Standard',
  },
  {
    value: 'SEWA_TEMPAT',
    title: 'Sewa Tempat',
  },
  {
    value: 'SEWA_TEMPAT_TANPA_NAMA_PERUSAHAAN',
    title: 'Sewa Tempat Tanpa Nama Perusahaan',
  },
];
